<template>
  <a-form :form="form" id="components-form-login" @submit="handleSubmit" class="login-form">
    <a-form-item>
      <a-input
        placeholder="Username"
        v-decorator="[
          'userName',
          { rules: [{ required: true, message: 'Silahkan masukan username!' }] }
        ]"
        v-model="user.username"
      >
        <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input
        v-decorator="[
          'password',
          { rules: [{ required: true, message: 'Silahkan masukan Password!' }] }
        ]"
        type="password"
        placeholder="Password"
        v-model="user.password"
      >
        <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-checkbox
        style="color:#40a9ff"
        v-decorator="[
          'remember_me',
          {
            valuePropName: 'remember_me',
            initialValue: true,
          }
        ]"
        v-model="user.remember_me"
      >Ingat Saya</a-checkbox>
      <a class="login-form-forgot" href>Lupa password ?</a>
      <a-button type="primary" htmlType="submit" class="login-form-button">Masuk</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
export default {
  data: function() {
    return {
      user: {
        username: "",
        password: "",
        remember_me: true
      }
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      // eslint-disable-next-line no-unused-vars
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit("submited", this.user);
        }
      });
    }
  }
};
</script>

<style scoped>
#components-form-login .login-form {
  max-width: 300px;
}
#components-form-login .login-form-forgot {
  float: right;
}
#components-form-login .login-form-button {
  width: 100%;
}
</style>